import { render, staticRenderFns } from "./results-kpi-analysis.vue?vue&type=template&id=67671670&scoped=true"
import script from "./results-kpi-analysis.vue?vue&type=script&lang=ts"
export * from "./results-kpi-analysis.vue?vue&type=script&lang=ts"
import style0 from "./results-kpi-analysis.vue?vue&type=style&index=0&id=67671670&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67671670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67671670')) {
      api.createRecord('67671670', component.options)
    } else {
      api.reload('67671670', component.options)
    }
    module.hot.accept("./results-kpi-analysis.vue?vue&type=template&id=67671670&scoped=true", function () {
      api.rerender('67671670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/results/sections/results-kpi-analysis.vue"
export default component.exports